import IAuthToken from 'models/Auth'

const AUTH_LOCAL_STORAGE_KEY = 'user'
const getAuth = (): IAuthToken | undefined => {
 if (!localStorage) {
  return
 }

 const lsValue: string | null = localStorage.getItem(
  AUTH_LOCAL_STORAGE_KEY
 )
 if (!lsValue) {
  return
 }
 try {
  const user: IAuthToken = JSON.parse(lsValue) as IAuthToken
  if (user) {
   // You can easily check auth_token expiration also
   return user
  }
 } catch (error) {
  console.error('AUTH LOCAL STORAGE PARSE ERROR', error)
 }
}

const setAuth = (auth: IAuthToken) => {
 if (!localStorage) {
  return
 }

 try {
  const lsValue = JSON.stringify(auth)
  localStorage.setItem(AUTH_LOCAL_STORAGE_KEY, lsValue)
 } catch (error) {
  console.error('AUTH LOCAL STORAGE SAVE ERROR', error)
 }
}

const removeAuth = () => {
 if (!localStorage) {
  return
 }

 try {
  const lsValue = localStorage.getItem(
   AUTH_LOCAL_STORAGE_KEY
  )
  const selectedLanguage = lsValue
   ? JSON.parse(lsValue).selectedLanguage
   : null
  localStorage.removeItem(AUTH_LOCAL_STORAGE_KEY)
  localStorage.setItem(
   'user',
   JSON.stringify({
    selectedLanguage: selectedLanguage ?? 'en',
   })
  )
 } catch (error) {
  console.error('AUTH LOCAL STORAGE REMOVE ERROR', error)
 }
}

export {
 getAuth,
 setAuth,
 removeAuth,
 AUTH_LOCAL_STORAGE_KEY,
}
